module.exports = __webpack_public_path__ + "static/media/green-candy.6e0fe0a2.png";